import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDateRange } from './hooks/use-date-range';
import DateRangeFilter from './components/date-range-filter';
import UsersSection from './sections/users-section';
import MembershipsSection from './sections/memberships-section';
import ChatSection from './sections/chat-section';
import RevisionSection from './sections/revision-section';
import PreparationSection from './sections/preparation-section';

/**
 * Dashboard de analytics del admin. Página contenedora pura: solo maneja el
 * layout y el estado del rango de fechas compartido -- cada sección hace su
 * propio fetch (ver sections/*.tsx) y es responsable de su propio dato.
 *
 * Dos zonas separadas a propósito: "Estado actual" (snapshots que no usan
 * rango de fechas) y "Tendencias" (todo lo que sí depende del filtro de
 * arriba). Mezclarlas visualmente daría a entender que el filtro afecta
 * todo el dashboard, cuando en realidad varios endpoints del backend no
 * aceptan startDate/endDate en absoluto.
 */
const AdminAnalytics = () => {
  const dispatch = useDispatch();
  const { range, setRange } = useDateRange();

  useEffect(() => {
    dispatch({
      type: 'SET_HEADER',
      payload: { title: 'Analytics', onBack: null },
    });
  }, [dispatch]);

  return (
    <div id='admin-analytics'>
      <div className='analytics-toolbar'>
        <div>
          <h2>Analytics</h2>
          <p>Visión general de usuarios, membresías, chat, revisión y elaboración documental</p>
        </div>
        <DateRangeFilter range={range} onChange={setRange} />
      </div>

      <UsersSection range={range} />
      <MembershipsSection range={range} />
      <ChatSection range={range} />
      <RevisionSection range={range} />
      <PreparationSection range={range} />
    </div>
  );
};

export default AdminAnalytics;
